import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/public.less';
// import './assets/reset.css'  // 统一浏览器内核的css样式
import axios from './api/axiosConfig'
// require('./api/axiosConfig')   // 导入 axios全局配置
import '@/assets/icons/index.js'
import directives from './api/directives/index'


import { handleTree } from '@/api/common';
import {
  sumArr,
  flatten,
  deepClone,
  getString,
  parseTime,
  resetForm,
  resetField,
  formatLocal,
  parseStrEmpty,
  beforeFileUpload,
  formatDictToText,
  uniqueArr,
  uniqueArr2,
  uniqueArr3,
  myFixed,
  fileInfo,
  fileShow,
  formatPrice,
  ThousandAndDecimal,
  groupClassByKey,
  // 合并行
  mergeIndexRows,
  dealMergeIndexObj,
  customMergeIndex,
} from '@/utils/common';
Vue.prototype.customMergeIndex = customMergeIndex;
Vue.prototype.dealMergeIndexObj = dealMergeIndexObj;
Vue.prototype.mergeIndexRows = mergeIndexRows;
Vue.prototype.formatPrice = formatPrice;
Vue.prototype.groupClassByKey = groupClassByKey;
Vue.prototype.sumArr = sumArr;
Vue.prototype.fileShow = fileShow;
Vue.prototype.flatten = flatten;
Vue.prototype.uniqueArr = uniqueArr;
Vue.prototype.uniqueArr2 = uniqueArr2;
Vue.prototype.uniqueArr3 = uniqueArr3;
Vue.prototype.deepClone = deepClone;
Vue.prototype.getString = getString;
Vue.prototype.formatDictToText = formatDictToText;
Vue.prototype.resetField = resetField; // 表单重置
Vue.prototype.resetForm = resetForm; // 表单重置
Vue.prototype.parseTime = parseTime; // 日期格式化
Vue.prototype.formatLocal = formatLocal;
Vue.prototype.parseStrEmpty = parseStrEmpty; // 空格式化
Vue.prototype.beforeFileUpload = beforeFileUpload;
Vue.prototype.fileInfo = fileInfo;
Vue.prototype.myFixed = myFixed;
Vue.prototype.ThousandAndDecimal = ThousandAndDecimal;

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(directives);
Vue.prototype.handleTree = handleTree; // 构造树型结构数据
Vue.prototype.resetForm = resetForm; // 表单重置
import { pcaa } from 'area-data-vue';
import 'area-linkage-vue/dist/index.css';
import AreaLinkageVue from 'area-linkage-vue';
Vue.prototype.$pcaa = pcaa;

Vue.use(AreaLinkageVue)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
